// Vue packages
import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueValidator from 'vue-validator'

// Vuex instance
import store from './vuex/store' // vuex store instance

// Use validator
Vue.use(VueValidator)

// Install router
Vue.use(VueRouter)

// Sync vue-router and vuex
var router = new VueRouter()
sync(store, router)

// Declare and configure vue-resource
Vue.use(VueResource)
Vue.http.options.root = 'api'

Vue.filter('reverse', function (value) {
  return value.split('').reverse().join('')
})

Vue.directive('uppercase', {
  twoWay: true, // this transformation applies back to the vm
  bind: function () {
    this.handler = function () {
      this.set(this.el.value.toUpperCase())
    }.bind(this)
    this.el.addEventListener('input', this.handler)
  },
  unbind: function () {
    this.el.removeEventListener('input', this.handler)
  }
})

// Import components
import App from 'src/App.vue'
import AgendaView from 'src/components/views/AgendaView.vue'
import ContactView from 'src/components/views/ContactView.vue'
import AdministrationView from 'src/components/views/AdministrationView.vue'
import LoginView from 'src/components/views/LoginView.vue'
import ProjectView from 'src/components/views/ProjectView.vue'

// Users components
import UsersList from 'src/components/users/UsersList.vue'
import UserAdd from 'src/components/users/UserAdd.vue'
import UserEdit from 'src/components/users/UserEdit.vue'

// Agenda components
import Calendar from 'src/components/calendar/Calendar.vue'
import MeetingAdd from 'src/components/meetings/MeetingAdd.vue'
import MeetingEdit from 'src/components/meetings/MeetingEdit.vue'

// Contacts components
import ContactsList from 'src/components/contacts/ContactsList.vue'
import ContactAdd from 'src/components/contacts/ContactAdd.vue'
import ContactEdit from 'src/components/contacts/ContactEdit.vue'
import ContactPlanning from 'src/components/contacts/ContactPlanning.vue'
import ContactParcours from 'src/components/contacts/ContactParcours.vue'
import ContactEditEntreprises from 'src/components/contacts/ContactEditEntreprises.vue'
import ContactEditEmplois from 'src/components/contacts/ContactEditEmplois.vue'
import ContactEditFormations from 'src/components/contacts/ContactEditFormations.vue'
import ContactEditCapes from 'src/components/contacts/ContactEditCapes.vue'
import ContactEditCers from 'src/components/contacts/ContactEditCers.vue'

// Projects components
import ProjectsList from 'src/components/projects/ProjectsList.vue'
import ProjectAdd from 'src/components/projects/ProjectAdd.vue'
import ProjectEdit from 'src/components/projects/ProjectEdit.vue'
import ProjectPlanning from 'src/components/projects/ProjectPlanning.vue'
// import ProjectEditCape from 'src/components/projects/ProjectEditCape.vue'
// import ProjectEditCer from 'src/components/projects/ProjectEditCer.vue'
import ProjectEditSortie from 'src/components/projects/ProjectEditSortie.vue'

// Map components to routes

router.beforeEach(transition => {
  if (!router.app.userAuthenticated) {
    router.go('/login')
  }
  transition.next()
})

router.map({
  '/': {
    component: AgendaView,
    subRoutes: {
      '/': {
        name: 'calendar',
        component: Calendar
      },
      '/add': {
        name: 'addMeeting',
        component: MeetingAdd
      },
      '/edit/:meetingId': {
        name: 'editMeeting',
        component: MeetingEdit
      },
      '/add/:contactId': {
        name: 'addMeetingWithContact',
        component: MeetingAdd
      },
      '/add/:contactId/:projectId': {
        name: 'addMeetingWithProject',
        component: MeetingAdd
      }
    }
  },
  '/login': {
    component: LoginView
  },
  '/contact': {
    component: ContactView,
    subRoutes: {
      '/list': {
        component: ContactsList
      },
      '/add': {
        component: ContactAdd
      },
      '/edit/:contactId': {
        name: 'editContact',
        component: ContactEdit
      },
      '/planning/:contactId': {
        name: 'planningContact',
        component: ContactPlanning
      },
      '/parcours/:contactId': {
        name: 'parcoursContact',
        component: ContactParcours
      },
      '/edit/entreprises/:contactId': {
        name: 'editContact.entreprises',
        component: ContactEditEntreprises
      },
      '/edit/emplois/:contactId': {
        name: 'editContact.emplois',
        component: ContactEditEmplois
      },
      '/edit/formations/:contactId': {
        name: 'editContact.formations',
        component: ContactEditFormations
      },
      '/edit/capes/:contactId': {
        name: 'editContact.capes',
        component: ContactEditCapes
      },
      '/edit/cers/:contactId': {
        name: 'editContact.cers',
        component: ContactEditCers
      }
    }
  },
  '/project': {
    component: ProjectView,
    subRoutes: {
      '/list': {
        component: ProjectsList
      },
      '/add': {
        component: ProjectAdd
      },
      '/add/:contactId': {
        name: 'addProjectWithContact',
        component: ProjectAdd
      },
      '/edit/:projectId': {
        name: 'editProject',
        component: ProjectEdit
      },
      '/planning/:projectId': {
        name: 'planningProject',
        component: ProjectPlanning
      },
      /*
      '/edit/cape/:projectId': {
        name: 'editProject.cape',
        component: ProjectEditCape
      },
      */
      /*
      '/edit/cer/:projectId': {
        name: 'editProject.cer',
        component: ProjectEditCer
      },
      */
      '/edit/sortie/:projectId': {
        name: 'editProject.sortie',
        component: ProjectEditSortie
      }
    }
  },
  '/administration': {
    component: AdministrationView,
    subRoutes: {
      '/': {
        component: UsersList
      },
      '/add': {
        component: UserAdd
      },
      '/edit/:userId': {
        name: 'editUser',
        component: UserEdit
      }
    }
  }
})

// Scroll top after page change
router.beforeEach(function () {
  window.scrollTo(0, 0)
})

// Here we go
router.start(App, '#app')



// WEBPACK FOOTER //
// ./src/main.js